import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Trophy, Library, Brain, Settings, ScrollText, ShieldAlert, Users, Plus, BarChart3 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const SECTIONS = [
    {
        label: "Tổng quan",
        items: [
            { to: "/quan-tri", icon: LayoutDashboard, label: "Bảng điều khiển", end: true },
            { to: "/thong-ke", icon: BarChart3, label: "Phân tích thống kê" },
        ],
    },
    {
        label: "Cuộc thi",
        items: [
            { to: "/quan-tri/cuoc-thi/moi", icon: Plus, label: "Tạo cuộc thi mới" },
        ],
    },
    {
        label: "Nội dung",
        items: [
            { to: "/quan-tri/thu-vien", icon: Library, label: "Thư viện tài liệu" },
        ],
    },
    {
        label: "Vận hành",
        items: [
            { to: "/giam-khao", icon: Users, label: "Cổng Ban giám khảo" },
        ],
    },
    {
        label: "Cấu hình",
        items: [
            { to: "/quan-tri/cai-dat-ai", icon: Brain, label: "AI Providers" },
        ],
    },
];

export default function AdminLayout() {
    const { user } = useAuth();
    return (
        <main className="pt-16 min-h-screen flex">
            {/* Sidebar */}
            <aside className="hidden lg:flex flex-col w-64 fixed top-16 bottom-0 left-0 bg-[var(--navy-deep)] text-white overflow-y-auto z-30">
                <div className="px-5 py-5 border-b border-white/10">
                    <div className="flex items-center gap-3">
                        <img src="/logo-cucdanso.png" alt="" className="w-10 h-10 rounded-full bg-white p-0.5" />
                        <div>
                            <div className="font-heading font-bold text-sm">Quản trị Hệ thống</div>
                            <div className="text-[10px] text-[var(--gold)] tracking-widest">CỤC DÂN SỐ · BỘ Y TẾ</div>
                        </div>
                    </div>
                </div>
                <nav className="flex-1 px-3 py-4 space-y-5">
                    {SECTIONS.map((sec) => (
                        <div key={sec.label}>
                            <div className="text-[10px] uppercase tracking-widest text-slate-400 px-3 mb-2 font-bold">{sec.label}</div>
                            <div className="space-y-1">
                                {sec.items.map((it) => (
                                    <NavLink key={it.to} to={it.to} end={it.end}
                                        className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                                        data-testid={`sidebar-${it.to.replace(/\//g, "-")}`}>
                                        <it.icon className="w-4 h-4 flex-shrink-0" />
                                        <span>{it.label}</span>
                                    </NavLink>
                                ))}
                            </div>
                        </div>
                    ))}
                </nav>
                <div className="border-t border-white/10 p-4">
                    <div className="text-xs text-slate-400">Đăng nhập:</div>
                    <div className="text-sm font-semibold mt-0.5">{user?.full_name}</div>
                    <Link to="/" className="text-xs text-[var(--gold)] hover:underline mt-2 block">← Về trang công khai</Link>
                </div>
            </aside>

            {/* Content */}
            <div className="flex-1 lg:ml-64 min-w-0">
                <Outlet />
            </div>
        </main>
    );
}
